import React from 'react';
import numbro from 'numbro';
import OrderDetail from './orderDetail';
import PanelLoading from '../../components/panelLoading';

const sevenLink = 'https://www.newebpay.com/info/site_description/seven_ibon_embedded';
const okLink = 'https://www.newebpay.com/info/site_description/okshop_embedded';
const famiLink = 'https://www.newebpay.com/info/site_description/family_embedded';
const hilifeLink = 'https://www.newebpay.com/info/site_description/hilife_embedded';


function AtmResult(props) {
    const { userInfo, data, paymentMethods, order } = props;
    const { paymentInfo1, paymentInfo2, paymentInfo3, amount } = order;
    return (
        <div>
            <h4>Pub點數訂購完成</h4>
            <p>請於繳費期限內至ATM或郵局轉帳，完成交易，謝謝！</p>
            <hr />
            <dl className="dl-horizontal" style={{ padding: '0px 50px' }}>
                <dt>轉帳銀行代號</dt>
                <dd><strong style={{ color: '#e67a24' }}>{paymentInfo1}</strong></dd>
                <dt>轉帳帳號</dt>
                <dd><strong style={{ color: '#e67a24' }}>{paymentInfo2}</strong></dd>
                <dt>轉帳金額</dt>
                <dd><strong style={{ color: '#e67a24' }}>{numbro(amount).format('0,0')}元</strong></dd>
                <dt>繳費期限</dt>
                <dd><strong style={{ color: '#e67a24' }}>{paymentInfo3}</strong></dd>
            </dl>
            <hr />
            <OrderDetail order={order} userInfo={userInfo} data={data} paymentMethods={paymentMethods}/>
        </div >
    );
}

function MmkResult(props) {
    const { userInfo, data, paymentMethods, order } = props;
    const { paymentInfo1, paymentInfo2, amount } = order;
    return (
        <div>
            <h4>Pub點數訂購完成</h4>
            <p>請於繳費期限內至超商繳費，完成交易，謝謝！</p>
            <hr />
            <dl className="dl-horizontal" style={{ padding: '0px 50px' }}>
                <dt>繳費編號</dt>
                <dd><strong style={{ color: '#e67a24' }}>{paymentInfo1}</strong></dd>
                <dt>繳費金額</dt>
                <dd><strong style={{ color: '#e67a24' }}>{numbro(amount).format('0,0')} 元</strong></dd>
                <dt>繳費期限</dt>
                <dd><strong style={{ color: '#e67a24' }}>{paymentInfo2}</strong></dd>
            </dl>
            <hr />
            <OrderDetail order={order} userInfo={userInfo} data={data} paymentMethods={paymentMethods}/>
            <hr />
            <dl>
                <dt>繳費方式</dt>
                <dd>
                    <span style={{color:'red'}}>請留意 2020/04/20 之後繳費流程略有異動，請依下列步驟操作</span><br/>
                    請依簡訊記錄上列14位繳費編號，到四大超商選擇代碼繳費，輸入14碼繳費編號，印出繳費單到櫃檯繳費。
                    <ul style={{ paddingLeft: '20px' }}>
                        <li>【7-11 ibon】繳費請參考<a href={sevenLink} target="_blank">7-11 ibon付款流程</a>。</li>
                        <li>【全家 FamiPort】請點選「繳費」。<a href={famiLink} target="_blank">全家 FamiPort付款流程</a>。</li>
                        <li>【OK 超商 OK-go】請點選「繳費」。<a href={okLink} target="_blank">OK 超商 OK-go付款流程</a>。</li>
                        <li>【萊爾富 Life-ET】請點選「繳費、代收」。<a href={hilifeLink} target="_blank">萊爾富 Life-ET付款流程</a>。</li>                    
                    </ul>
                </dd>    
                {/* <dd>
                    請依簡訊記錄上列16位繳費編號，到萊爾富Life-ET、OK超商OK–GO 依下列路徑點選按鈕，選擇「ezPay (或藍新金流)」→「帳單查繳」並輸入16碼繳費編號，印出繳費單到櫃檯繳費
                    <ul style={{ paddingLeft: '20px' }}>
                        <li>萊爾富 Life-ET：請在「代收繳款」選單下，「網路交易」→「ezPay (或藍新金流)」→「帳單查繳」→輸入16碼繳費編號，列印出繳費條碼單，請持往櫃台繳費</li>
                        <li>OK超商 OK–GO ：請在「繳費」選單下，選擇「會員繳費」→「ezPay (或藍新金流)」→「帳單查繳」→輸入16碼繳費編號，列印出繳費條碼單，請持往櫃台繳費</li>
                    </ul>
                </dd> */}
                <dt>請注意</dt>
                <dd>
                    印出的繳費單有效期限為3小時。如逾時未繳，請重新印出新的繳費單。
                    每張繳費單僅能繳款一次，請勿重覆列印同一張繳費單重覆繳。
                </dd>
            </dl>
        </div >
    );
}

function Result(props) {
    const { order, data, userInfo, paymentMethods } = props;
    switch (order.paymentMethodId) {
        case 2:
            return <AtmResult order={order} data={data} userInfo={userInfo} paymentMethods={paymentMethods}/>;
        case 5:
            return <MmkResult order={order} data={data} userInfo={userInfo} paymentMethods={paymentMethods}/>;
        case 52:
            return <AtmResult order={order} data={data} userInfo={userInfo} paymentMethods={paymentMethods}/>;
        case 55:
            return <MmkResult order={order} data={data} userInfo={userInfo} paymentMethods={paymentMethods}/>;
        default:
            return <div></div>;
    }
}

function Pay(props) {
    const { order, loading, close, data, userInfo, paymentMethods, jumpToStep } = props;
    return (
        <div className="panel panel-default" style={{ marginTop: '30px' }}>
            <div className="panel-heading">Step4. 繳費</div>
            <div className="panel-body">
                {loading  && <PanelLoading />}
                <Result order={order} data={data} userInfo={userInfo} paymentMethods={paymentMethods}/>
                <hr />
                <button
                    className="btn btn-pubgame"
                    style={{ float: 'right' }}
                    onClick={() => {
                        close();
                        jumpToStep(0);
                    }}>
                    完成並返回儲值首頁
                </button>
            </div>
        </div>
    );
}

export default Pay;


// WEBPACK FOOTER //
// ./src/containers/shop/pay.jsx